<template>
    <div>
      <div class="live-box">
        <div class="line move1"></div>
        <div class="line move2"></div>
        <div class="line move3"></div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      color: {
        type: String,
        default: '#fff'
      }
    },
    data() {
      return {
        lineColor: this.color
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .live-box {
    width: 12px;
    height: 20px;
    justify-content: space-between;
    display: flex;
    align-items: center;
  }
  
  .line {
    width: 2px;
    height:12px;
    background-color: v-bind(lineColor);
    border-radius: 2px;
  }
  
  
  .move1 {
    transform: scaleY(0.2);
    animation: mymove1 0.7s 0.1s infinite linear alternate;
  }
  
  .move2 {
    transform: scaleY(1);
    animation: mymove2 0.7s 0.4s infinite linear alternate;
  }
  
  .move3 {
    transform: scaleY(0.1);
    animation: mymove3 0.7s 0.4s infinite linear alternate;
  }
  
  @keyframes mymove1 {
    0% {
      transform: scaleY(0.2);
    }
    100% {
      transform: scaleY(1);
    }
  }
  
  @keyframes mymove2 {
    0% {
      transform: scaleY(1);
    }
    
    100% {
      transform: scaleY(0.3);
    }
  }
  
  @keyframes mymove3 {
    0% {
      transform: scaleY(0.1);
    }
  
    100% {
      transform: scaleY(1);
    }
  }
  </style>
  